import React from "react";

export default function FaqInfo({ children }) {
  return <div className='right-side'>{children}</div>;
}
